module.exports = __webpack_public_path__ + "static/media/DDsketch2.bd5256db.png";